/**
 * INTERIM shared content width for the storefront's account-portal surfaces.
 *
 * Why this exists: no page in `ecommerce-web` shares a shell, so every page
 * hand-rolls its own `px-4 py-N max-w-* mx-auto` root and picked its cap ad
 * hoc. Measured on the Capital Trading storefront at a 1440px viewport, one
 * signed-in session crossed four different content widths — dashboard 1280,
 * lists and account 896, order detail and payments 768, password 448 — so
 * moving between pages visibly re-flowed the column. Seven distinct caps are
 * in use across all 21 pages.
 *
 * This constant is a stopgap that collapses the account-portal surfaces onto
 * one width. It is deliberately NOT a design-system primitive:
 *
 *   - The style-guide project already owns this defect as **D-4** ("no shared
 *     page shell", `PageHeader` used in 2 of 71 page components) with a
 *     proposed `PageShell` primitive, and **Q5** flags shell adoption as a
 *     blocker for other work (`docs/claude/style-guide/`).
 *   - That spec covers header + actions + content region but does not yet
 *     define content WIDTH, and the guide carries no width tokens at all.
 *   - `ecommerce-web` has its own Tailwind config and does not consume
 *     `libs/web-ui`'s preset, so it is outside the token layer today.
 *
 * When `PageShell` lands and its content-region width is settled, delete this
 * file and migrate these pages onto it — the point of routing every call
 * through one symbol is that the migration is a find-and-replace, not another
 * sweep of 21 hand-written caps. Do not grow this into a width scale in the
 * meantime; take that to the style guide instead.
 *
 * Catalog-shaped pages (catalog grid, cart, product, promo) are intentionally
 * left alone — a product grid wants more room than a record list, and those
 * surfaces are live for other tenants.
 */
export const PAGE_CONTENT = 'max-w-4xl mx-auto';
